import { render, staticRenderFns } from "./dstableForm.vue?vue&type=template&id=7a671b9f&scoped=true&"
import script from "./dstableForm.vue?vue&type=script&lang=js&"
export * from "./dstableForm.vue?vue&type=script&lang=js&"
import style0 from "./dstableForm.vue?vue&type=style&index=0&id=7a671b9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a671b9f",
  null
  
)

export default component.exports